<script setup lang="ts">
import { computed } from 'vue'
import { useThemeStore } from '@/stores/themeStore'
import Button from 'primevue/button';
import { useRouter } from 'vue-router';
import { MAIN_ROUTER_PAGE } from '@/utils/consts';

const router = useRouter()
const themeStore = useThemeStore()
const colorSchemeIcon = computed(() => themeStore.mode == 'dark' ? 'pi pi-moon' : 'pi pi-sun')
</script>

<template>
  <div class="absolute bottom-auto top-0 end-0">
    <Button :icon="colorSchemeIcon" class="m-3" @click="themeStore.toggle()" variant="text" rounded
      aria-label="Theme" />
  </div>
  <div class="flex items-center justify-center mt-15 lg:mt-30">
    <div class="w-300 px-10 lg:px-5">
      <span class="font-bold text-5xl">{{ $t("pageError") }}</span>
      <p class="mb-0 mt-3 text-2xl">{{ $t("pageForbidden") }}. <a :href="router.resolve(MAIN_ROUTER_PAGE).fullPath">{{
        $t("backToHome") }}</a></p>
    </div>
  </div>
</template>
